import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';
import type { BriefingTopic } from './dailyBriefingData';

interface EditTopicModalProps {
    visible: boolean;
    topic: BriefingTopic | null;
    saving: boolean;
    onDismiss: () => void;
    onSave: (title: string) => Promise<void>;
}

export function EditTopicModal({ visible, topic, saving, onDismiss, onSave }: EditTopicModalProps) {
    const [title, setTitle] = useState('');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (visible && topic) {
            setTitle(topic.title);
            setError(null);
        }
    }, [visible, topic]);

    const handleSubmit = async () => {
        if (!title.trim()) {
            setError('Title is required.');
            return;
        }
        setError(null);
        await onSave(title.trim());
    };

    return (
        <CustomModal
            visible={visible}
            onDismiss={onDismiss}
            header="Edit Topic"
            size="default"
            footer={
                <div className="db-modal-footer-actions">
                    <Btn variant="secondary" buttonText="Cancel" buttonOnClick={onDismiss} buttonDisabled={saving} />
                    <Btn
                        variant="primary"
                        buttonText={saving ? 'Saving…' : 'Save'}
                        buttonOnClick={handleSubmit}
                        buttonDisabled={saving}
                    />
                </div>
            }
        >
            <div className="db-form-stack">
                <label className="db-field">
                    <span className="db-field-label">Topic title</span>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="db-input"
                        disabled={saving}
                        aria-invalid={Boolean(error)}
                        aria-describedby={error ? 'db-edit-topic-error' : undefined}
                    />
                </label>
                {error ? (
                    <p className="db-modal-error" role="alert" id="db-edit-topic-error">
                        {error}
                    </p>
                ) : null}
            </div>
        </CustomModal>
    );
}
